export default {
    name: 'Header'
}
